import React, { useContext } from 'react';
import { Button, Container, Stack, ThemeProvider, Typography } from '@mui/material';
import ProductManagementTable from './ProductManagementTable';
import MainBreadCrumb from '../../wrappers/breadcrumb/MainBreadCrumb';
import { newTheme } from '../../components/theme/theme';
import { AuthContext } from '../../common/Auth';
import { useThemeSettings } from '../../layouts/state/useThemeSettings';
import { useHistory } from 'react-router-dom';
import { List } from '@mui/icons-material';

export default function ProductManagementPage() {
  const history = useHistory();
  const { settingData } = useContext(AuthContext);
  const { themedefaultColor, themedefaultTextColor, defaultFont } = useThemeSettings({
    settingData,
  });

  const handleViewInventoryReport = () => {
    history.push('/product-management/inventory-report');
  };

  return (
    <ThemeProvider
      theme={newTheme({ themedefaultColor, themedefaultTextColor, fontFamily: defaultFont })}
    >
      <MainBreadCrumb />
      <Container maxWidth="xl">
        <Stack>
          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography variant="h4" gutterBottom>
              Products
            </Typography>
            <Button variant={'outlined'} onClick={handleViewInventoryReport} startIcon={<List />}>
              Inventory Report
            </Button>
          </Stack>
          <ProductManagementTable />
        </Stack>
      </Container>
    </ThemeProvider>
  );
}
